<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      :show-save-button="false"
      title="余料解绑单详情"
      :data="data"
      id-key="workorderunbindingeditDialog"
      @close-saved="$emit('close-saved')"
      lineForm
      inline
    >
      
      <template slot="form">
        <el-form-item label="解绑单号" >
          <span>{{ data.DocNo }}</span>
        </el-form-item>
        <el-form-item label="解绑时间" >
          <span>{{ $commonJs.toDateString(data.DocDate) }}</span>
        </el-form-item>
        <el-form-item label="解绑人" >
          <span>{{ data.EmpName }}</span>
        </el-form-item>
      </template>

      <el-table ref="list" border :data="tableData" style="width: 100%">
        <el-table-column
          key="key1"
          prop="WorkDocNo"
          label="工单号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          key="key2"
          prop="ProductName"
          label="材料名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          key="key3"
          prop="ProductNo"
          label="材料编码"
          min-width="120"
        ></el-table-column>
        <el-table-column
          key="key4"
          prop="ProductSpec"
          label="规格"
          min-width="120"
        ></el-table-column>
        <el-table-column
          key="key5"
          prop="PropertyName"
          label="属性"
          min-width="120"
        ></el-table-column>
        <el-table-column
            key="key6"
            prop="ColorName"
            label="颜色"
            min-width="120"
          ></el-table-column>
          <el-table-column
            key="key7"
            prop="BaseQuantity"
            label="主数量"
            min-width="120"
          ></el-table-column>
          <el-table-column
            key="key8"
            prop="Quantity"
            label="解绑数量"
            min-width="120"
          ></el-table-column>
      </el-table>
    
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/production/unBindMaterial').default,
      data: {
        EmpName: "",
        DocDate: "",
        DocNo: "",
      },
      tableData: [],
    }
  },
  methods: {
    setData(row){
      let id = row.DocId;
      this.data.EmpName = row.EmpName;
      this.data.DocDate = row.DocDate;
      this.data.DocNo = row.DocNo;
      this.api.vDetail({Id: id}).then(res => {
        if(res.Code === 0){
          this.tableData = res.Data
        }
      })
      
    }
  }

};
</script>
